export interface IFetchSitesEnergyDataParams {
    siteIds?: number[];
    sans?: string[];
    date: {
        start: Date;
        end: Date;
    };
}

export interface IRequestEnergyUsageParams {
    source: 'sce' | 'pge' | 'coned';
    enrollmentIds?: string[];
    date: {
        start: Date;
        end: Date;
    };
}

export interface IEnergyUsageRequest {
    id: string;

    source: string;

    type: string;

    start: string;

    end: string;

    actor: string;

    status: string;

    metadata: any;

    createdAt: string;

    updatedAt: string;
}

export type EnergyUsageTimeseriesValueDto = [number, number, number, number, number?, number?, number?, number?, number?, number?, number?];

export interface EnergyUsageTimeseriesDto {
    enrollmentId: string;
    fields: [
        'timestamp',
        'usageKw',
        'qualityOfReading',
        'flowDirection',
        'baselineCaiso10dUnadjustedKw',
        'baselineCaiso10dAdjustedKw',
        'performanceCaiso10dKw',
        'baseline3hKw',
        'performance3hKw',
        'baselineStaticKw',
        'performanceStaticKw',
    ];
    values: EnergyUsageTimeseriesValueDto[];
}

export function getTimestamp(val: EnergyUsageTimeseriesValueDto) {
    const TIMESTAMP_POSITION = 0;
    return val[TIMESTAMP_POSITION] ?? null;
}

export function getUsageKw(val: EnergyUsageTimeseriesValueDto) {
    const USAGE_KW_POSITION = 1;
    return val[USAGE_KW_POSITION] ?? null;
}

export function getBaselineCaiso10d(val: EnergyUsageTimeseriesValueDto) {
    const BASELINE_CAISO_10D_UNADJUSTED_POSITION = 4;
    const BASELINE_CAISO_10D_ADJUSTED_POSITION = 5;
    return val[BASELINE_CAISO_10D_ADJUSTED_POSITION] ?? val[BASELINE_CAISO_10D_UNADJUSTED_POSITION];
}

export function getPerformanceCaiso10d(val: EnergyUsageTimeseriesValueDto) {
    const PERFORMANCE_CAISO_10D_POSITION = 6;
    return val[PERFORMANCE_CAISO_10D_POSITION] ?? null;
}

export function getBaselineStatic(val: EnergyUsageTimeseriesValueDto) {
    const BASELINE_STATIC_POSITION = 9;
    return val[BASELINE_STATIC_POSITION] ?? null;
}

export function getPerformanceStatic(val: EnergyUsageTimeseriesValueDto) {
    const PERFORMANCE_STATIC_POSITION = 10;
    return val[PERFORMANCE_STATIC_POSITION] ?? null;
}

export enum EventSourceType {
    EVENT = 'event',
    PRICE_RESPONSE = 'price-response-event',
    CLEAN_RESPONSE = 'clean-response-event',
}

export interface EnergyEventDto {
    siteId?: number;
    id?: number;
    start: string;
    duration: number;
    preDuration: number;
    secondaryPreDuration: number;
    postDuration: number;
    eventSourceType: EventSourceType;
}
